export default __webpack_public_path__ + "static/media/wwf_big@2x.d7d769c0.jpg";